type LogArgs = any[]

const isDebugEnabled = () => {
  try {
    // W DEV loguj tylko gdy ustawiono flagę w localStorage
    return !import.meta.env.PROD && localStorage.getItem('debugLogs') === '1'
  } catch {
    return false
  }
}

export const logger = {
  debug: (...args: LogArgs) => {
    if (isDebugEnabled()) console.log(...args)
  },
  info: (...args: LogArgs) => {
    if (isDebugEnabled()) console.info(...args)
  },
  warn: (...args: LogArgs) => console.warn(...args),
  error: (...args: LogArgs) => console.error(...args),
}

export default logger


